import { api } from './api';

/**
 * @param {{ screen: string, question: string, locale: string, context?: object, history?: { role: string, content: string }[] }} body
 * @param {{ signal?: AbortSignal }} [opts]
 */
export async function postFlowIaChat(body, opts = {}) {
  const res = await api.post('/api/flow-ia/chat', body, { signal: opts.signal });
  return res.data;
}

export async function getFlowIaStatus() {
  const res = await api.get('/api/flow-ia/status');
  return res.data;
}
